<template>
  <div>
    <div id="searcher">
      <div class="wrapper">
        <div class="search-box">
          <div class="search-data">
            <!-- 已收录
            <span>{{ reportTotal }}</span>
            篇研究报告，
            <span>{{ dataTotal }}</span>
            条行业数据 -->
            <!-- 昨日新增
            <span>{{ reportUpdateCount }}</span>
            篇 -->
          </div>
          <div class="search-text">
            <h2>轻研智库 研判未来</h2>
          </div>
          <el-input
            placeholder="请输入检索词"
            v-model="searchInput"
            class="search-input"
            @keyup.enter.native="handleSearch"
          >
            <el-select
              class="search-input_select"
              v-model="searchSelect"
              slot="prepend"
              placeholder="请选择"
            >
              <el-option label="数据情报" :value="1"></el-option>
              <el-option label="发现报告" :value="0"></el-option>
              <el-option label="产业政策" :value="3"></el-option>
              <el-option label="数据快递" :value="4"></el-option>
              <el-option label="国内经济" :value="5"></el-option>
              <el-option label="国际动态" :value="6"></el-option>
            </el-select>
            <el-button
              class="search-input_button"
              slot="append"
              @click="handleSearch"
              >检索</el-button
            >
          </el-input>
          <!-- <div class="search-hot">
            热点搜索：
            <a
              href="javascript:;"
              v-for="(item, index) in hotKeywords"
              :key="index"
              @click="handleHotKeyword(item)"
            >
              {{ item }}
            </a>
          </div> -->
          <div class="search-hot" v-if="searchSelect === 0">
            热点搜索：
            <a
              href="javascript:;"
              v-for="(item, index) in reportHotSearch"
              :key="index"
              @click="handleHotKeyword(item.name)"
            >
              {{ item.name }}
            </a>
          </div>
          <div class="search-hot" v-if="searchSelect === 1">
            热点搜索：
            <a
              href="javascript:;"
              v-for="(item, index) in dataHotSearch"
              :key="index"
              @click="handleHotKeyword(item.name)"
            >
              {{ item.name }}
            </a>
          </div>
          <div class="search-hot" v-if="searchSelect === 3">
            热点搜索：
            <a
              href="javascript:;"
              v-for="(item, index) in policyHotSearch"
              :key="index"
              @click="handleHotKeyword(item.name)"
            >
              {{ item.name }}
            </a>
          </div>
          <div class="search-hot" v-if="searchSelect === 4">
            热点搜索：
            <a
              href="javascript:;"
              v-for="(item, index) in sjkdHotSearch"
              :key="index"
              @click="handleHotKeyword(item.name)"
            >
              {{ item.name }}
            </a>
          </div>
          <div class="search-hot" v-if="searchSelect === 5">
            热点搜索：
            <a
              href="javascript:;"
              v-for="(item, index) in gnjjHotSearch"
              :key="index"
              @click="handleHotKeyword(item.name)"
            >
              {{ item.name }}
            </a>
          </div>
          <div class="search-hot" v-if="searchSelect === 6">
            热点搜索：
            <a
              href="javascript:;"
              v-for="(item, index) in gjdtHotSearch"
              :key="index"
              @click="handleHotKeyword(item.name)"
            >
              {{ item.name }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div id="body">
      <section>
        <div class="wrapper">
          <div class="top-earth">
            <div class="mapbox" ref="mapSpace"></div>
          </div>
          <div class="top-intro">
            <div class="text">
              <h2>轻研全球产业发展数据</h2>
              <p>
                轻研聚焦中国的全球战略合作伙伴，提供及时快速的商品贸易数据，以及国内重点产业经济数据查询服务
              </p>
            </div>
            <div class="data" v-loading="indexDataLoading">
              <ul>
                <li>
                  <span ref="cyDataDiqu">{{ indexDataCounts[0] }}</span>
                  <small>+ </small>
                  <sub>重点地区数据</sub>
                </li>
                <li>
                  <span ref="cyDataJingji">{{ indexDataCounts[1] }}</span>
                  <small>+ </small>
                  <sub>宏观经济数据</sub>
                </li>
                <li>
                  <span ref="cyDataHangye">{{ indexDataCounts[2] }}</span>
                  <small>+ </small>
                  <sub>行业图谱数据</sub>
                </li>
                <li>
                  <span ref="cyDataMaoyi">{{ indexDataCounts[3] }}</span>
                  <small>+ </small>
                  <sub>商品贸易数据</sub>
                </li>
              </ul>
            </div>
          </div>
          <el-tabs class="top-tabs" @tab-click="handleTabClick">
            <el-tab-pane name="t1">
              <div class="top-tabs_title" slot="label">
                <span class="pic"
                  ><img src="~@/assets/images/top-tabs-title-pic1.png" alt=""
                /></span>
                <span class="name">产业导航</span>
                <span class="intro">国家经济发展的产业标准分类</span>
              </div>
            </el-tab-pane>
            <el-tab-pane name="t2">
              <div class="top-tabs_title" slot="label">
                <span class="pic"
                  ><img src="~@/assets/images/top-tabs-title-pic2.png" alt=""
                /></span>
                <span class="name">企业导航</span>
                <span class="intro">提升全天下企业的核心竞争力</span>
              </div>
            </el-tab-pane>
            <el-tab-pane name="t3">
              <div class="top-tabs_title" slot="label">
                <span class="pic"
                  ><img src="~@/assets/images/top-tabs-title-pic3.png" alt=""
                /></span>
                <span class="name">高校导航</span>
                <span class="intro">产业和科技人才培养的主阵地</span>
              </div>
            </el-tab-pane>
            <el-tab-pane name="t4">
              <div class="top-tabs_title" slot="label">
                <span class="pic"
                  ><img src="~@/assets/images/top-tabs-title-pic4.png" alt=""
                /></span>
                <span class="name">区域导航</span>
                <span class="intro">全球大变局下经济发展新引擎</span>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </section>
      <section class="diagram">
        <div class="ibox">
          <div class="ibox_title">
            <h2>行业图谱</h2>
            <sub>汇聚百万研究报告，解析千万行业图谱</sub>
          </div>
          <div class="ibox_content">
            <div class="diagram-list">
              <el-skeleton :loading="loading" :count="8" animated>
                <template slot="template">
                  <dl>
                    <dt>
                      <el-skeleton-item variant="h2" />
                    </dt>
                    <dd class="pic">
                      <el-skeleton-item variant="image" />
                    </dd>
                    <dd class="info">
                      <span class="t">
                        <el-skeleton-item
                          variant="text"
                          style="width: 66px"
                        /> </span
                      ><span class="o">
                        <el-skeleton-item variant="text" style="width: 66px" />
                      </span>
                    </dd>
                    <dd class="bottom">
                      <el-skeleton-item variant="text" style="width: 80px" />
                      <el-skeleton-item variant="button" style="width: 80px" />
                    </dd>
                  </dl>
                </template>
                <template>
                  <dl v-for="(item, index) in records" :key="index">
                    <dt v-if="item.picTitle">
                      <span
                        v-html="
                          item.picTitle.replace(
                            /[图表]+?[\d-]{0,6}[:：\s\.]+/g,
                            ''
                          )
                        "
                      ></span>
                      <span v-if="showNewTab(item.date)" class="status s-new"
                        >上新</span
                      >
                      <!-- <span v-if="showDeepTab(item.pdfTab)" class="status s-deep"
                  >深度</span
                > -->
                    </dt>
                    <dd class="pic">
                      <el-image
                        :src="item.picPath"
                        @click="showImgViewer(index)"
                        lazy
                      >
                        <div slot="error" style="margin-top: -120px">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </el-image>
                    </dd>
                    <dd class="info">
                      <span class="t" v-if="item.date">{{
                        dateFormat(item.date)
                      }}</span>
                      <span
                        class="o"
                        v-if="item.industry && item.industry.length > 0"
                      >
                        <span
                          v-for="(industry, index) in item.industry"
                          :key="index"
                          v-html="industry"
                        ></span
                      ></span>
                    </dd>
                    <dd class="bottom">
                      <el-tag v-if="item.picType && item.picType.length > 0">
                        <img src="~@/assets/images/icon-tag.png" alt="" />
                        <span
                          v-for="(picType, index) in item.picType"
                          :key="index"
                        >
                          {{ (index > 0 ? "| " : "") + picType }}
                        </span>
                      </el-tag>
                      <template v-if="item.pdfPath">
                        <el-button
                          size="small"
                          @click="viewPath(item.id, item.picPath, item.title)"
                          v-if="
                            item.pdfPath.substring(
                              item.pdfPath.lastIndexOf('.')
                            ) === '.pdf'
                          "
                        >
                          <img
                            src="~@/assets/images/icon-view.png"
                            alt=""
                          />查看原文
                          <!-- <el-link :href="item.pdfPath" target="_blank">
                    <img src="~@/assets/images/icon-view.png" alt="" />查看原文
                  </el-link> -->
                        </el-button>
                        <el-button
                          size="small"
                          @click="
                            handleDownloadImgReport(
                              item.id,
                              item.title,
                              item.pdfPath.substring(
                                item.pdfPath.lastIndexOf('.')
                              )
                            )
                          "
                          v-else
                        >
                          <img
                            src="~@/assets/images/icon-view.png"
                            alt=""
                          />查看原文
                          <!-- <el-link :href="item.pdfPath" target="_blank">
                    <img src="~@/assets/images/icon-view.png" alt="" />查看原文
                  </el-link> -->
                        </el-button>
                      </template>
                    </dd>
                  </dl>

                  <div class="no-data" v-if="!records || records.length === 0">
                    <div class="tip">
                      <svg
                        t="1626241932884"
                        class="icon"
                        viewBox="0 0 1428 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="2321"
                        width="60"
                        height="60"
                      >
                        <path
                          d="M982.129778 353.975309H572.833185C556.689383 353.975309 543.604938 339.854222 543.604938 322.37037s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 290.765432 1011.358025 304.886519 1011.358025 322.37037S998.286222 353.975309 982.117136 353.975309M982.129778 467.753086H572.833185C556.689383 467.753086 543.604938 453.632 543.604938 436.148148s13.071802-31.604938 29.240889-31.604938h409.271309C998.311506 404.54321 1011.358025 418.664296 1011.358025 436.148148S998.286222 467.753086 982.117136 467.753086M805.293827 594.17284H572.681481c-16.080593 0-29.076543-14.121086-29.076543-31.604939s12.995951-31.604938 29.076543-31.604938h232.612346c16.080593 0 29.076543 14.121086 29.076543 31.604938S821.37442 594.17284 805.293827 594.17284"
                          p-id="2322"
                        ></path>
                        <path
                          d="M501.304889 173.675457c-12.995951 0-23.627852 10.49284-23.627852 23.400296v743.626272c0 12.894815 10.631901 23.387654 23.640494 23.387654h602.895802c13.033877 0 23.640494-10.49284 23.640494-23.387654V197.075753c0-12.894815-10.606617-23.387654-23.640494-23.387654h-602.895802zM1104.225975 1024H501.304889C454.934123 1024 417.185185 986.642963 417.185185 940.689383V197.088395C417.185185 151.122173 454.934123 113.777778 501.304889 113.777778h602.921086C1150.622025 113.777778 1188.345679 151.134815 1188.345679 197.088395v743.600988c0 45.95358-37.723654 83.310617-84.119704 83.310617z"
                          p-id="2323"
                        ></path>
                        <path
                          d="M1216.840691 910.222222h-68.54479v-59.897679h68.54479c13.451062 0 24.778272-10.214716 24.778272-22.287802V82.17284c0-12.073086-11.32721-22.287802-24.778272-22.287803H616.245728c-13.451062 0-24.778272 10.214716-24.778271 22.287803v65.068246H530.962963V82.17284C530.962963 36.851358 569.21758 0 616.245728 0h600.594963C1263.86884 0 1302.123457 36.851358 1302.123457 82.185481V828.049383C1302.123457 873.370864 1263.86884 910.222222 1216.840691 910.222222"
                          p-id="2324"
                        ></path>
                        <path
                          d="M1399.049481 910.222222H1192.555457C1176.247309 910.222222 1163.061728 896.088494 1163.061728 878.617284s13.18558-31.604938 29.493729-31.604938h206.494024c16.308148 0 29.493728 14.133728 29.493729 31.604938s-13.18558 31.604938-29.493729 31.604938M514.528395 1024H281.916049c-16.080593 0-29.076543-14.133728-29.076543-31.604938s12.995951-31.604938 29.076543-31.604939h232.612346c16.080593 0 29.076543 14.133728 29.076543 31.604939S530.608988 1024 514.528395 1024M173.372049 1024H28.899556C12.920099 1024 0 1009.866272 0 992.395062S12.920099 960.790123 28.899556 960.790123h144.472493C189.351506 960.790123 202.271605 974.923852 202.271605 992.395062S189.351506 1024 173.372049 1024M326.580148 50.567901h-58.987457C259.451259 50.567901 252.839506 44.904296 252.839506 37.925926s6.611753-12.641975 14.753185-12.641975h58.987457C334.72158 25.283951 341.333333 30.947556 341.333333 37.925926s-6.611753 12.641975-14.753185 12.641975"
                          p-id="2325"
                        ></path>
                        <path
                          d="M290.765432 88.493827c-6.97837 0-12.641975-6.611753-12.641975-14.753185V14.753185C278.123457 6.611753 283.787062 0 290.765432 0s12.641975 6.611753 12.641975 14.753185v58.987457C303.407407 81.882074 297.743802 88.493827 290.765432 88.493827M273.901037 480.395062h-67.407012C197.176889 480.395062 189.62963 471.924938 189.62963 461.432099s7.547259-18.962963 16.864395-18.962963h67.407012c9.317136 0 16.864395 8.470123 16.864395 18.962963s-7.547259 18.962963-16.864395 18.962963"
                          p-id="2326"
                        ></path>
                        <path
                          d="M233.876543 505.679012c-10.49284 0-18.962963-7.547259-18.962963-16.864395v-67.407012c0-9.317136 8.470123-16.864395 18.962963-16.864395s18.962963 7.547259 18.962963 16.864395v67.407012c0 9.317136-8.470123 16.864395-18.962963 16.864395M132.740741 142.222222a28.444444 28.444444 0 1 0 0.025284 56.914173 28.444444 28.444444 0 0 0-0.025284-56.914173m0 85.333334A56.952099 56.952099 0 0 1 75.851852 170.666667C75.851852 139.289284 101.363358 113.777778 132.740741 113.777778s56.888889 25.511506 56.888889 56.888889-25.511506 56.888889-56.888889 56.888889M1384.296296 231.765333a14.791111 14.791111 0 0 0-14.753185 14.753186 14.791111 14.791111 0 0 0 14.753185 14.753185 14.791111 14.791111 0 0 0 14.753185-14.753185 14.791111 14.791111 0 0 0-14.753185-14.753186m0 59.000099c-24.399012 0-44.246914-19.847901-44.246913-44.246913s19.847901-44.246914 44.246913-44.246914 44.246914 19.847901 44.246914 44.246914-19.847901 44.246914-44.246914 44.246913"
                          p-id="2327"
                        ></path>
                      </svg>
                      <div class="text">暂无数据</div>
                    </div>
                  </div>
                </template>
              </el-skeleton>
            </div>
          </div>
        </div>
      </section>
      <section class="hot">
        <div class="ibox">
          <div class="ibox_title">
            <h2>热点情报</h2>
            <sub>以大数据为依托，助力产业结构研究和经济决策</sub>
          </div>
          <div class="ibox_content">
            <div class="hot-list">
              <div class="list-box weeks">
                <div class="list-box_title">
                  <h4>研报榜单</h4>
                </div>
                <div class="list-box_content">
                  <ul>
                    <li v-for="(item, index) in yearHotReport" :key="index">
                      <span class="no">{{ index + 1 }}</span>

                      <el-tooltip placement="top-start" effect="light">
                        <div slot="content" v-html="item.title"></div>
                        <a
                          class="name"
                          :href="
                            '/report/read?id=' +
                            item.id +
                            '&type=0&title=' +
                            item.title
                          "
                          target="_blank"
                          v-if="
                            item.pdfPath.substring(
                              item.pdfPath.lastIndexOf('.')
                            ) === '.pdf'
                          "
                        >
                          {{ cutstring(item.title, 42) }}
                        </a>
                        <a
                          v-else
                          href="javascript:;"
                          @click="
                            handleDownload(
                              item.id,
                              item.title,
                              item.pdfPath.substring(
                                item.pdfPath.lastIndexOf('.')
                              )
                            )
                          "
                        >
                          {{ cutstring(item.title, 42) }}
                        </a>
                      </el-tooltip>

                      <span class="time">{{ dateFormat(item.date) }}</span>
                      <el-tooltip placement="bottom-start" effect="light">
                        <div slot="content" v-html="item.institution"></div>
                        <span class="from">{{ item.institution }}</span>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="list-box months">
                <div class="list-box_title">
                  <h4>最新政策</h4>
                </div>
                <div class="list-box_content">
                  <ul>
                    <li v-for="(item, index) in policyHotList" :key="index">
                      <span class="no">{{ index + 1 }}</span>
                      <el-tooltip placement="top-start" effect="light">
                        <div slot="content" v-html="item.title"></div>
                        <a
                          class="name"
                          :href="'/policy/detail?id=' + item._id"
                          target="_blank"
                        >
                          {{ cutstring(item.title, 42) }}
                        </a>
                      </el-tooltip>
                      <span class="time">
                        {{ dateFormat(item.publish_time) }}
                      </span>
                      <el-tooltip placement="bottom-start" effect="light">
                        <div
                          slot="content"
                          v-html="
                            item.organ.indexOf(';') > -1
                              ? item.organ.substring(0, item.organ.indexOf(';'))
                              : item.organ
                          "
                        ></div>
                        <span class="from" v-if="item.organ">
                          {{
                            item.organ.indexOf(";") > -1
                              ? item.organ.substring(0, item.organ.indexOf(";"))
                              : item.organ
                          }}
                        </span>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="list-box days">
                <div class="list-box_title">
                  <h4>数据快递</h4>
                </div>
                <div class="list-box_content">
                  <ul>
                    <li v-for="(item, index) in dataNewsHotList" :key="index">
                      <span class="no">{{ index + 1 }}</span>
                      <el-tooltip placement="top-start" effect="light">
                        <div slot="content" v-html="item.title"></div>
                        <a
                          class="name"
                          :href="'/news/detail?id=' + item.Id + '&type=1'"
                          target="_blank"
                        >
                          {{ cutstring(item.title, 42) }}
                        </a>
                      </el-tooltip>
                      <span class="time">
                        {{ dateFormat(item.publishTime) }}
                      </span>
                      <el-tooltip placement="bottom-start" effect="light">
                        <div
                          slot="content"
                          v-html="
                            item.source && item.source.length > 0
                              ? item.source[0]
                              : ''
                          "
                        ></div>
                        <span class="from">
                          {{
                            item.source && item.source.length > 0
                              ? item.source[0]
                              : ""
                          }}
                        </span>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="tail">
        <div class="wrapper">
          <div class="tbox">
            <div class="tbox_title">
              <h4>
                <img src="@/assets/images/logo.svg" alt="" />
                <!-- <img src="@/assets/images/logo-text.svg" alt="" /> -->
              </h4>
            </div>
            <div class="tbox_content">
              <p v-html="aboutUsContent"></p>
              <p class="link">
                <a
                  href="javascript:;"
                  @click="showAgreementContent(index)"
                  v-for="(item, index) in agreementList"
                  :key="index"
                >
                  《{{ item.title }}》
                </a>
                <!-- <a href="#">《用户协议》</a><a href="#">《侵权举报》</a> -->
              </p>
            </div>
          </div>
          <div class="tbox">
            <div class="tbox_title">
              <h4>联系方式</h4>
            </div>
            <div class="tbox_content">
              <p>销售服务热线：023-67882612</p>
              <p>技术服务热线：023-67680812</p>
              <p>投诉反馈：vip@cqvip.com</p>
              <p>地 址：重庆市两江新区洪湖西路18号3栋附2号</p>
            </div>
          </div>
          <div class="tbox">
            <div class="tbox_title">
              <h4>微信订阅</h4>
            </div>
            <div class="tbox_content">
              <!-- <img src="~@/assets/images/code.png" alt="" /> -->
              <img src="~@/assets/images/code-o.png" width="150" alt="" />
            </div>
          </div>
          <div class="tbox">
            <div class="tbox_title">
              <h4>联系我们</h4>
            </div>
            <div class="tbox_content">
              <!-- <img src="~@/assets/images/code.png" alt="" /> -->
              <img src="~@/assets/images/qrcode.png" width="150" alt="" />
            </div>
          </div>
        </div>
      </section>
    </div>
    <el-dialog
      :visible.sync="imgViewerVisible"
      width="1100px"
      class="report-picshow"
      :before-close="closeImgViewer"
    >
      <div class="intro">
        <img class="logo" src="@/assets/images/logo.svg" alt="" />
        <p>
          轻研智库全面覆盖各投资领域，依托海量的宏观策略、行业发展、上市公司等研究报告，采用智能搜索引擎、专业OCR识别、文档结构化解析、自然语言处理等技术，致力于为金融投资人员、企业高管、咨询顾问、行业研究员、市场分析师、市场运营人员等提供便捷、全面的实时、专业的信息检索服务。
        </p>
      </div>

      <div class="picshow">
        <el-carousel
          trigger="click"
          :autoplay="false"
          arrow="always"
          indicator-position="none"
          ref="carousel"
          @change="handleCarouselChange"
        >
          <el-carousel-item v-for="(item, index) in records" :key="index">
            <label
              v-if="item && item.picTitle"
              v-html="
                item.picTitle
                  .replace(/(<([^>]+)>)/gi, '')
                  .replace(/[图表]+?[\d-]{0,6}[:：\s\.]+/g, '')
              "
            >
            </label>
            <el-image :src="item.picPath"></el-image>
          </el-carousel-item>
        </el-carousel>
      </div>

      <div class="report-info">
        <div
          class="title"
          v-if="records[imgViewerIndex] && records[imgViewerIndex].title"
          v-html="records[imgViewerIndex].title.replace(/(<([^>]+)>)/gi, '')"
        ></div>
        <div class="info">
          <span
            class="t"
            v-if="records[imgViewerIndex] && records[imgViewerIndex].date"
          >
            <img src="~@/assets/images/icon-time.png" alt="" />
            {{ dateFormat(records[imgViewerIndex].date) }}
          </span>
        </div>
        <div class="bottom">
          <span
            class="type"
            v-if="records[imgViewerIndex] && records[imgViewerIndex].industry"
          >
            {{ records[imgViewerIndex].industry[0] }}
          </span>
          <span class="op">
            <el-button size="small" @click="downloadImg">
              <img src="~@/assets/images/icon-download.png" alt="" />
              下载
            </el-button>
          </span>
        </div>
      </div>
    </el-dialog>
    <el-dialog :title="agreementTitle" :visible.sync="showAgreement">
      <span v-html="agreementContent"></span>
    </el-dialog>
  </div>
</template>

<script>
import { axiosOptions, axiosRequest } from "../util/request";
import moment from "moment";
import {
  cutstr,
  downloadReport,
  downloadDataIntelligenceImg,
} from "../util/utils";

import geoJson from "@/assets/map/word.json";
import language from "@/assets/map/lange.json";

import * as echarts from "echarts";
import "echarts-gl";

export default {
  data() {
    return {
      imgViewerVisible: false,
      topTabs: "t1",
      guidTabs: "0",
      searchInput: "",
      searchSelect: 1,
      aboutUsContent: "",
      agreementList: [],
      showAgreement: false,
      agreementTitle: "",
      agreementContent: "",
      hotKeywords: [
        "汽车芯片",
        "扫地机器人",
        "自动驾驶",
        "锂电池",
        "储能",
        "数字化转型",
      ],
      reportTotal: 0,
      reportUpdateCount: 0,
      dataTotal: 0,
      reportHotSearch: [],
      dataHotSearch: [],
      policyHotSearch: [],
      sjkdHotSearch: [],
      gnjjHotSearch: [],
      gjdtHotSearch: [],
      // dayHotReport: [],
      // weekHotReport: [],
      // monthHotReport: [],
      records: [],
      imgList: [],
      imgViewerIndex: 0,
      yearHotReport: [],
      policyHotList: [],
      dataNewsHotList: [],
      indexDataCounts: [],
      indexDataLoading: false,
      loading: false,
      baseTexture: null,
      myChart: null,
      seasColor: "#c5e5fe", //海洋区域颜色
      nareaColor: "#eaeff2", //区域默认颜色
      nareaborderColor: "#96d0ff", //区域边框颜色
      eareaColor: "#35a5ff", //鼠标悬浮区域颜色
      ncolor: "#35a5ff", //区域名称颜色
      nfontSize: 14, //区域名称字体大小
      ecolor: "#fff", //区域名称悬浮颜色
      efontSize: 18, //区域名称悬浮字体大小
      boxbackgroundColor: "auto", //盒子背景颜色
    };
  },
  created() {
    // if (
    //   !this.$store.state.logined &&
    //   !sessionStorage.getItem("getLoginStatus")
    // ) {
    //   sessionStorage.setItem("getLoginStatus", true);
    //   this.$router.push("/login");
    // }

    this.getHotSearch();

    // this.getReportCount();

    this.getHotReport();
    this.getPolicyHotList();
    this.getDataNewsHotList();
    this.getDiagramSearch();
    this.getAboutUsContent();
    this.getAgreement(1);
    this.getAgreement(6);
  },
  mounted() {
    this.sethui();

    this.getIndexDataCount();

    //初始化地图
    this.myChart = echarts.init(this.$refs["mapSpace"]);
    this.getBaseTexture();
  },
  methods: {
    sethui() {
      var element = document.createElement("script");
      element.src = "https://www.buidea.com/static/front/js/cqvipbase.js";
      document.body.appendChild(element);
    },
    numberGrow(ele, value, time) {
      //let step = (_this.value * 10) / (_this.time * 1000);
      let step = parseInt((value / time) * 10);
      let current = 0;
      let start = 0;
      let t = setInterval(function () {
        start += step;
        if (start > value) {
          clearInterval(t);
          start = value;
          t = null;
        }
        if (current === start) {
          return;
        }
        current = start;
        ele.innerHTML = current
          .toString()
          .replace(/(\d)(?=(?:\d{3}[+]?)+$)/g, "$1,");
      }, 10);
    },
    getIndexDataCount() {
      this.indexDataLoading = true;
      axiosRequest(
        "/tool/index-data-count",
        {},
        axiosOptions("get", "", "json")
      )
        .then((res) => {
          this.indexDataLoading = false;
          if (res.data.code === 200) {
            res.data.data.forEach((element) => {
              this.indexDataCounts.push(parseInt(element));
            });
            this.numberGrow(
              this.$refs.cyDataDiqu,
              this.indexDataCounts[0],
              600
            );
            this.numberGrow(
              this.$refs.cyDataJingji,
              this.indexDataCounts[1],
              600
            );
            this.numberGrow(
              this.$refs.cyDataHangye,
              this.indexDataCounts[2],
              600
            );
            this.numberGrow(
              this.$refs.cyDataMaoyi,
              this.indexDataCounts[3],
              600
            );
            // this.indexDataCounts = res.data.data;
          }
        })
        .catch(() => {
          this.indexDataLoading = false;
        });
    },
    getPolicyHotList() {
      axiosRequest(
        "/search/policy-index-list",
        {},
        axiosOptions("post", "", "json")
      ).then((res) => {
        if (res.data.code === 200) {
          this.policyHotList = res.data.data;
        }
      });
    },
    getDataNewsHotList() {
      axiosRequest(
        "/search/data-news-index-list",
        {},
        axiosOptions("post", "", "json")
      ).then((res) => {
        if (res.data.code === 200) {
          this.dataNewsHotList = res.data.data;
        }
      });
    },
    getHotSearch() {
      axiosRequest(
        "/tool/hot-search",
        {},
        axiosOptions("get", "", "json")
      ).then((res) => {
        if (res.data && res.data.code === 200) {
          this.reportHotSearch = res.data.data.item1;
          this.dataHotSearch = res.data.data.item2;
          this.policyHotSearch = res.data.data.item3;
          this.sjkdHotSearch = res.data.data.item4;
          this.gnjjHotSearch = res.data.data.item5;
          this.gjdtHotSearch = res.data.data.item6;
        }
      });
    },
    getHotReport() {
      axiosRequest(
        "/tool/hot-report",
        {},
        axiosOptions("get", "", "json")
      ).then((res) => {
        if (res.data && res.data.code === 200) {
          this.yearHotReport = res.data.data.item1;
          // this.dayHotReport = res.data.data.item1;
          // this.weekHotReport = res.data.data.item2;
          // this.monthHotReport = res.data.data.item3;
        }
      });
    },
    handleTabClick(tab) {
      switch (tab.name) {
        case "t1":
          this.$router.push("/nav/industry");
          break;
        case "t2":
          this.$router.push("/nav/company");
          break;
        case "t3":
          this.$router.push("/nav/school");
          break;
        case "t4":
          this.$router.push("/nav/region");
          break;
      }
    },
    getReportCount() {
      // axiosRequest(
      //   "/tool/report-count",
      //   {},
      //   axiosOptions("get", "", "json")
      // ).then((res) => {
      //   if (res.data.code === 200) {
      //     this.reportTotal = res.data.data[0];
      //     this.reportUpdateCount = res.data.data[1];
      //   }
      // });

      axiosRequest(
        "/search/total-count",
        {},
        axiosOptions("get", "", "json")
      ).then((res) => {
        if (res.data.code === 200) {
          this.reportTotal = res.data.data[0];
          this.dataTotal = res.data.data[1];
        }
      });
    },
    getAboutUsContent() {
      axiosRequest(
        "/about-us/content",
        {},
        axiosOptions("get", "", "json")
      ).then((res) => {
        if (res.data.code === 200) {
          this.aboutUsContent = res.data.data;
        }
      });
    },
    getAgreement(id) {
      axiosRequest(
        "agreement/details",
        { id: id },
        axiosOptions("post", "", "json")
      ).then((res) => {
        if (res.data.code === 200) {
          this.agreementList.push(res.data.data);
        }
      });
    },
    showAgreementContent(index) {
      const item = this.agreementList[index];
      if (item) {
        this.agreementTitle = item.title;
        this.agreementContent = item.content;
        this.showAgreement = true;
      }
    },
    cutstring(str, len) {
      return cutstr(str, len);
    },
    showKeyTechnology(item, len) {
      let result = [];
      if (item && item.keyTechnology) {
        result = item.keyTechnology
          .split(";")
          .filter((technology) => technology);
      }
      if (len) {
        result = result.splice(0, len);
      }

      return result;
    },
    handleSearch() {
      if (!this.searchInput) {
        this.$message.warning("请输入检索词");
        return;
      }

      switch (this.searchSelect) {
        case 0:
          this.$router.push({
            path: "/report/list",
            query: { keyword: this.searchInput },
          });
          break;
        case 1:
          this.$router.push({
            path: "/qingbao/list",
            query: { keyword: this.searchInput },
          });
          break;
        case 3:
          this.$router.push({
            path: "/policy/list",
            query: { keyword: this.searchInput },
          });
          break;
        case 4:
          this.$router.push({
            path: "/news/list",
            query: { filterTab: 1, keyword: this.searchInput },
          });
          break;
        case 5:
          this.$router.push({
            path: "/news/list",
            query: { filterTab: 2, keyword: this.searchInput },
          });
          break;
        case 6:
          this.$router.push({
            path: "/news/list",
            query: { filterTab: 3, keyword: this.searchInput },
          });
          break;
      }
    },
    handleHotKeyword(keyword) {
      switch (this.searchSelect) {
        case 0:
          this.$router.push({
            path: "/report/list",
            query: { keyword: keyword },
          });
          break;
        case 1:
          this.$router.push({
            path: "/qingbao/list",
            query: { keyword: keyword },
          });
          break;
        case 3:
          this.$router.push({
            path: "/policy/list",
            query: { keyword: keyword },
          });
          break;
        case 4:
          this.$router.push({
            path: "/news/list",
            query: { filterTab: 1, keyword: keyword },
          });
          break;
        case 5:
          this.$router.push({
            path: "/news/list",
            query: { filterTab: 2, keyword: keyword },
          });
          break;
        case 6:
          this.$router.push({
            path: "/news/list",
            query: { filterTab: 3, keyword: keyword },
          });
          break;
      }
    },
    dateFormat(cellValue) {
      if (!cellValue) return "";
      // return moment(cellValue).format("YYYY-MM-DD HH:mm:ss");
      return moment(cellValue).format("YYYY-MM-DD");
    },
    handleDownload(id, title, suffix) {
      downloadReport(0, id, title, suffix);
    },

    getDiagramSearch() {
      let params = {
        keywords: [], //["新能源汽车", "智能制造"],
        highlight: false,
        aggregations: false,
        pageIndex: 1,
        pageSize: 8,
        clusters: {},
        // filterTime: 3,
        // startTime: "2022-02-02 00:00:00",
        // endTime: "2023-02-03 00:00:00",
        sort: 0,
        filter: {},
      };
      axiosRequest(
        "/search/index-data-intelligence-match",
        params,
        axiosOptions("post", "application/json", "json")
      )
        .then((res) => {
          this.loading = false;

          if (res.data && res.data.code === 200) {
            this.records = res.data.data.results.records;
            this.imgList = this.records.map((i) => {
              return i.picPath;
            });
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handleCarouselChange(index, oldIndex) {
      this.imgViewerIndex = index;
    },
    getReportTitle() {
      if (this.records && this.records.length > this.imgViewerIndex) {
        const item = this.records[this.imgViewerIndex];
        if (item && item.title) {
          return item.title;
        }
      }

      return "";
    },
    getCurrentPicTitle() {
      if (this.records && this.records.length > this.imgViewerIndex) {
        const item = this.records[this.imgViewerIndex];
        if (item && item.picTitle) {
          return item.picTitle
            .replace(/(<([^>]+)>)/gi, "")
            .replace(/[图表]+?[\d-]{0,6}[:：\s\.]+/g, "");
        }
      }

      return "";
    },
    viewPath(id, picPath, title) {
      let page = "";
      if (picPath) {
        let filename = picPath.substring(picPath.lastIndexOf("/") + 1);
        page = filename.substring(0, filename.indexOf("_"));
      }
      let url = this.$router.resolve({
        path: "/report/read",
        query: { id: id, type: 1, page: page, title: title },
      });
      window.open(url.href, "_blank");
    },
    showImgViewer(index) {
      document.documentElement.style.overflowY = "hidden";
      this.imgViewerIndex = index;
      this.imgViewerVisible = true;
      setTimeout(() => {
        this.$refs.carousel.setActiveItem(index);
      }, 1);
    },
    closeImgViewer() {
      document.documentElement.style.overflowY = "auto";
      this.imgViewerVisible = false;
    },
    imgViewerOnSwitch(index) {
      this.imgViewerIndex = index;
    },
    downloadImg() {
      if (!this.records || this.records.length === 0) {
        return;
      }

      downloadDataIntelligenceImg(
        this.records[this.imgViewerIndex].id,
        this.getCurrentPicTitle()
      );
    },
    handleDownloadImgReport(id, title, suffix) {
      downloadReport(1, id, title, suffix);
    },
    showNewTab(date) {
      return (new Date() - new Date(date)) / (60 * 60 * 1000) / 24 < 7;
    },
    showDeepTab(tabs) {
      return (
        tabs && tabs.length > 0 && tabs.some((item) => item === "深度研究")
      );
    },

    // 生成球面纹理
    getBaseTexture() {
      echarts.registerMap("world", geoJson);
      let canvas = document.createElement("canvas");
      this.baseTexture = echarts.init(canvas, null, {
        width: 4096,
        height: 2048,
      });
      this.baseTexture.setOption({
        //海洋地区颜色
        backgroundColor: this.seasColor,
        geo: {
          type: "map",
          map: "world",
          left: 0,
          top: 0,
          right: 0,
          bottom: 0,
          boundingCoords: [
            [-180, 90],
            [180, -90],
          ],
          roam: false,
          //自定义地区名称映射
          nameMap: language,
          itemStyle: {
            normal: {
              areaColor: this.nareaColor,
              borderColor: this.nareaborderColor,
            },
            emphasis: {
              areaColor: this.eareaColor,
            },
          },
          label: {
            normal: {
              fontSize: this.nfontSize,
              show: false,
              textStyle: {
                color: this.ncolor,
              },
            },
            emphasis: {
              fontSize: this.efontSize,
              show: true,
              textStyle: {
                color: this.ecolor,
              },
            },
          },
          regions: [
            {
              name: "中国",
              selected: true,
            },
          ],
          select: {
            itemStyle: {
              areaColor: "#4ab6fe",
            },
          },
        },
      });
      this.drawEarth();
    },
    drawEarth() {
      let option = {
        // tooltip: {
        //   trigger: "item",
        // },
        globe: {
          baseTexture: this.baseTexture, // 基础纹理
          globeRadius: 103, // 球面半径
          environment: this.boxbackgroundColor,
          shading: "color",
          viewControl: {
            alpha: 30,
            beta: 160,
            //autoRotate: true, // 开启自动旋转
            autoRotateDirection: "ccw",
            autoRotateSpeed: 5,
            autoRotateAfterStill: 3,
            distance: 240,
            zoomSensitivity: 0,
          },
          zlevel: 1,
        },
        series: [
          {
            name: "lineList",
            type: "lines3D",
            coordinateSystem: "globe",
            effect: {
              show: true,
              period: 4, //特效动画的时间，单位为 s
              trailLength: 0.1, //特效尾迹的长度。0~1数值越大尾迹越长
              trailWidth: 3,
              trailColor: "#c0ffdf",
              trailOpacity: 1,
            },
            //blendMode: "lighter", //叠加高亮模式
            zlevel: 2,
            lineStyle: {
              color: "#85deff",
              opactiy: 0.1,
              width: 2,
            },
            data: [
              {
                coords: [
                  [116.512885, 39.847469],
                  [-73.97622, 40.757498], //美国
                ],
                value: 1848846,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [139.713657, 35.707004], //日本
                ],
                value: 1805216,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [13.40498, 52.521199], //德国
                ],
                value: 1274870,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [126.986407, 37.536804], //韩国
                ],
                value: 1189720,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [105.699615, 20.973967], //越南
                ],
                value: 1022736,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [101.681865, 3.136134], //马来西亚
                ],
                value: 979442,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [100.451117, 13.724061], //泰国
                ],
                value: 902392,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [-0.130058, 51.508604], //英国
                ],
                value: 882612,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [77.206503, 28.62928], //印度
                ],
                value: 838584,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [103.413384, 1.910925], //新加坡
                ],
                value: 827712,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [12.491267, 41.904612], //意大利
                ],
                value: 810046,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [137.708144, -25.328065], //澳大利亚
                ],
                value: 801362,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [106.870937, -6.240893], //印度尼西亚
                ],
                value: 725364,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [-109.404347, 60.638178], //加拿大
                ],
                value: 717060,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [2.333696, 48.865244], //法国
                ],
                value: 680392,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [37.621612, 55.758257], //俄罗斯联邦
                ],
                value: 646052,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [120.985715, 14.603576], //菲律宾
                ],
                value: 635340,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [4.89354, 52.370649], //荷兰
                ],
                value: 628708,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [18.480216, -33.873348], //南非
                ],
                value: 608708,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [7.459498, 9.126437], //尼日利亚
                ],
                value: 528708,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [13.285773, -8.748538], //安哥拉
                ],
                value: 428708,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [-70.693344, 19.48165], //智利
                ],
                value: 328708,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [-74.074104, 4.715315], //哥伦比亚
                ],
                value: 228708,
              },
              {
                coords: [
                  [116.512885, 39.847469],
                  [-77.042548, -12.044223], //秘鲁
                ],
                value: 128708,
              },
            ],
            silent: false,
          },
          {
            name: "ms-powerpoint",
            type: "scatter3D",
            coordinateSystem: "globe",
            symbol: "circle",
            symbolSize: "3",
            effect: {
              show: true,
              period: 4, //特效动画的时间，单位为 s
              trailLength: 0.1, //特效尾迹的长度。0~1数值越大尾迹越长
              trailWidth: 3,
              trailColor: "#c0ffdf",
              trailOpacity: 1,
            },
            //blendMode: "lighter", //叠加高亮模式
            zlevel: 2,
            itemStyle: {
              color: "transparent",
              borderWidth: 2,
              borderColor: "#85deff",
              opactiy: 0.1,
            },
            data: [
              {
                value: [-73.97622, 40.757498], //美国
              },
              {
                value: [139.713657, 35.707004], //日本
              },
              {
                value: [13.40498, 52.521199], //德国
              },
              {
                value: [126.986407, 37.536804], //韩国
              },
              {
                value: [105.699615, 20.973967], //越南
              },
              {
                value: [101.681865, 3.136134], //马来西亚
              },
              {
                value: [100.451117, 13.724061], //泰国
              },
              {
                value: [-0.130058, 51.508604], //英国
              },
              {
                value: [77.206503, 28.62928], //印度
              },
              {
                value: [103.413384, 1.910925], //新加坡
              },
              {
                value: [12.491267, 41.904612], //意大利
              },
              {
                value: [137.708144, -25.328065], //澳大利亚
              },
              {
                value: [106.870937, -6.240893], //印度尼西亚
              },
              {
                value: [-109.404347, 60.638178], //加拿大
              },
              {
                value: [2.333696, 48.865244], //法国
              },
              {
                value: [37.621612, 55.758257], //俄罗斯联邦
              },
              {
                value: [120.985715, 14.603576], //菲律宾
              },
              {
                value: [4.89354, 52.370649], //荷兰
              },
              {
                value: [18.480216, -33.873348], //南非
              },
              {
                value: [7.459498, 9.126437], //尼日利亚
              },
              {
                value: [13.285773, -8.748538], //安哥拉
              },
              {
                value: [-70.693344, 19.48165], //智利
              },
              {
                value: [-74.074104, 4.715315], //哥伦比亚
              },
              {
                value: [-77.042548, -12.044223], //秘鲁
              },
            ],
          },
        ],
      };
      //option.series[0].data = option.series[0].data.concat(this.rodamData());
      this.myChart.clear();
      this.myChart.setOption(option, true);
    },
    rodamData() {
      let longitude = 116.2;
      let latitude = 39.56;
      let longitude2 = 20.8666;
      let latitude2 = 44.0258;
      return {
        coords: [
          [longitude, latitude],
          [longitude2, latitude2],
        ],
        value: 3000,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/var.scss";
@import "@/assets/css/index.scss";

#body ::v-deep {
  .tail > .wrapper {
    .tbox:first-child {
      width: 33%;
    }
    .tbox {
      p {
        line-height: 33px;
      }
      p.link {
        margin-top: 10px;
      }
    }
    .tbox + .tbox + .tbox {
      width: auto;
      margin-left: 30px;
    }
  }
}
.list-box {
  vertical-align: top;
}

::v-deep .search-hot {
  display: block !important;
}
</style>
